import theme from "@/theme";

export const styles = {
  wrapper: {
    width: "100%",
  },

  heading: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "15px",
    lineHeight: "24px",
    letterSpacing: "0%",
    color: theme.palette.custom.blueGray900,
  },

  inputBox: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    height: "48px",
    padding: "10px 12px",
    borderRadius: "26px",
    border: "1px solid #E4E7E9",
  },

  firstInputBox: {},

  firstInput: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "22px",
    letterSpacing: "0%",
    color: theme.palette.custom.blueGray900,
    "& .MuiInputBase-input": {
      "::placeholder": {
        color: "#C6CACE",
        opacity: 1,
        textTransform: "capitalize",
      },
    },
  },

  subLabel: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "16px",
    letterSpacing: "0%",
    color: "#C6CACE",
    marginBottom: "10px",
    textTransform: "capitalize",
  },

  urlLabel: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "22px",
    color: "#2A2D31",
    marginRight: "10px",
    textTransform: "capitalize",
  },

  divider: {
    color: "#C6CACE",
    marginRight: "10px",
  },

  urlInput: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "22px",
    letterSpacing: "0",
    color: "#C6CACE",
    "& .MuiInputBase-input": {
      "::placeholder": {
        color: "#C6CACE",
        opacity: 1,
      },
    },
  },
};
